import { media, styled } from '@migros/msrc-ui-kit';
import { MINI_TILE_IMAGE_SIZE, MINI_TILE_IMAGE_SIZE_TABLET } from '../../../helpers';
export const ArticleMiniImage = styled.div`
  width: ${MINI_TILE_IMAGE_SIZE};
  height: ${MINI_TILE_IMAGE_SIZE};
  flex-shrink: 0;

  ${media.tabletAndUp`
    width: ${MINI_TILE_IMAGE_SIZE_TABLET};
    height: ${MINI_TILE_IMAGE_SIZE_TABLET};
  `}
`;